import React from "react";
import ReactTable from "react-table-v6";
import "react-table-v6/react-table.css";
import moment from "moment";
import config from "../config";
import api from "../utils/api";
import WorkingIndicator from "./partials/working-indicator.jsx";
import TransferHistoryTable from "./partials/transfer-history-table.jsx";
import AuditLogTable from "./partials/audit-log-table.jsx";
import connectToStores from "alt-utils/lib/connectToStores";
import PassActions from "../actions/PassActions";
import PassStore from "../stores/PassStore";
import UserStore from "../stores/UserStore";

const PAGESIZE = 10;

class PassHistory extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pass: null,
      passTransferHistory: null,
      pageData: [],
      pageNum: 0,
      isLoading: false
    };

    this.cleanSundanceEmail = this.cleanSundanceEmail.bind(this);
  }


  static get contextTypes() {
    return {
      router: React.PropTypes.object,
    };
  }

  static getStores() {
    return [PassStore, UserStore];
  }

  static getPropsFromStores() {
    return {
      isFetching: PassStore.getState().isFetching,
    };
  }

  componentWillMount() {
    PassActions.fetchPassTransferHistory.defer(this.props.params.passId, this.props.params.eventBucketId);
  }

  componentWillReceiveProps(newProps) {
    let passTransferHistory = PassStore.getPassTransferHistory();
    let passTransferHistorySinglePass = PassStore.getPassTransferHistorySinglePass();

    if (passTransferHistory && passTransferHistory.length >= 0) {
      this.setState({ passTransferHistory: passTransferHistory, pass: passTransferHistorySinglePass });
    }

    if (passTransferHistorySinglePass) {
      this.fetchPage();
    }
  }

  cleanSundanceEmail(email) {
    if (typeof email !== "string") {
      return "";
    }
    if (email.indexOf("%%%sundance-") !== -1) {
      return email.substring(0, email.indexOf("%%%sundance-"));
    }
    else {
      return email;
    }
  }

 fetchPage() {
    this.setState({ isLoading: true });
    api.request(
      {
        method: "GET",
        endpoint: `audit_log/page`,
        qs: {
          //eventBucket: this.props.params.eventBucketId,
          objectId: this.props.params.passId,
          pageSize: PAGESIZE,
          pageNum: this.state.pageNum
        },
        api_key: UserStore.getState().apiKey
      },
      function (err, response) {
        if (err) {
          console.log(err);
          alert(err);
          this.setState({ isLoading: false });
        }
        else {
          let pageData = response.data.map((r, i) => {
            return {
              key: i,
              event_bucket: r.event_bucket,
              object_id: r.object,
              user: r.user.name,
              action: r.action,
              created_at: r.created_at,
              user_account: r.user_account && r.user_account.name ? r.user_account.name : "Unknown / External API Call",
              //person: r.person[0] || "Not available",
              changes: r.changes
            };
          });

          let pageCount = Math.ceil(response.totalRecords / PAGESIZE);
          this.setState({ pageData: pageData, pageCount: pageCount, isLoading: false });
        }
      }.bind(this)
    );
  }

  render() {
    if (this.props.isFetching || this.state.passTransferHistory === null || this.state.pass === null) {
      return <WorkingIndicator fullPage={true} />;
    }

    if (this.state.passTransferHistory.length === 0) {
      return (
        <div>
          <div><span style={{ fontWeight: "bold", fontSize: "16px" }}>Pass Transfer History</span><br/>{this.props.params.passId}<br/><br/></div>
          <div>There is no transfer history for this pass.</div>
        </div>
      );
    }
    else {
      return (
        <div>
          <div style={{ paddingBottom: 25 }}><span style={{ fontWeight: "bold", fontSize: "18px" }}>Pass History - {this.props.params.passId}</span></div>
            <div><span style={{ fontWeight: "bold", fontSize: "16px" }}>Order Details</span></div>
            <div style={{ paddingBottom: 25 }}>
              <ReactTable
                columns={[
                  {
                    id: "date",
                    Header: "Date/Time",
                    Cell: function(data) {
                      return moment(data.original.date).format("lll")
                    }
                  },
                  {
                    id: "order_id",
                    Header: "Order ID",
                    Cell: function(data) {
                      return (<div><a href={`/event_buckets/${data.original.order.event_bucket}/orders/${data.original.order._id}`}>{data.original.order._id}</a></div>);
                    }
                  },
                  {
                    id: "ordered_by",
                    Header: "Ordered by",
                    Cell: function(data) {
                      return (<div><a href={`/people/${data.original.person.id}`}>{data.original.person.name}</a><br/>{data.original.person.email}</div>);
                    }
                  }
                ]}
                data={[
                  {
                    date: this.state.pass.order.created_at,
                    order: this.state.pass.order,
                    person: {
                      id: this.state.pass.order.person._id,
                      name: this.state.pass.order.person.name,
                      email: this.cleanSundanceEmail(this.state.pass.order.person.email)
                    }
                  }
                ]}
                loading={this.state.isLoading ? "Loading..." : null}
                manual
                pageSize={1}
                showPagination={false}
                showPageSizeOptions={false}
                sortable={false}
              />
            </div>

          <div><span style={{ fontWeight: "bold", fontSize: "16px" }}>Pass Transfer History</span></div>
          <div>
            <TransferHistoryTable
              records={this.state.passTransferHistory}
              loading={this.state.isLoading ? "Loading..." : null}
              isPass={true}
            />
          </div>

          <div style={{ paddingTop: 25 }}><span style={{ fontWeight: "bold", fontSize: "16px" }}>Pass Audit Log History</span></div>
          <div>
            <AuditLogTable
              logRecords={this.state.pageData}
              pageSize={this.state.pageData.length > PAGESIZE ? PAGESIZE : this.state.pageData.length}
              pages={this.state.pageCount || 1}
              loading={this.state.isLoading ? "Loading..." : null}
              onFetchData={(page, sorted, searchTerm) => {
               this.setState({
                  pageNum: page
                  //sorted,
                  //searchTerm
                }, function() {
                  this.fetchPage();
                });
             }}
            />
          </div>
        </div>
      ); 
    }
  }
}

export default connectToStores(PassHistory);



// WEBPACK FOOTER //
// ./src/app/components/pass-history.jsx